import { WEB_COMPONENT_SENSOR_AZURE_CW } from '../../../webcomponents.constants';
import { AzureCWSensorComponent } from './component/AzureCWSensorComponent';

export { AzureCWSensorComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_AZURE_CW, AzureCWSensorComponent);
